// extracted by mini-css-extract-plugin
module.exports = {"setupProjects":"SetupProjects_setupProjects__1ILgO","projects":"SetupProjects_projects__2w07Y"};